<template>
	<v-main>
		<div class="pa-4 flex-grow-1 overflow-hidden">
			<v-card id="mainContent">
				<router-view v-if="showRouterView" />
			</v-card>
		</div>
	</v-main>
</template>

<script>
import { mapGetters } from 'vuex';
import {
	ClientContextGetters,
	ProjectContextGetters,
} from '../../store/getters';
import { routesNames } from '../../enums/routesNames';

export default {
	name: 'LayoutView',
	computed: {
		...mapGetters({
			hasClient: [ClientContextGetters.HAS_CLIENT],
			hasProject: [ProjectContextGetters.HAS_PROJECT],
		}),
		showRouterView() {
			if (this.hasClient) {
				if (this.hasProject) {
					return true;
				} else {
					return this.hasClientNoProjectRoutes().includes(
						this.$route.name
					);
				}
			} else {
				return this.noClientNoProjectRoutes().includes(
					this.$route.name
				);
			}
		},
	},
	methods: {
		noClientNoProjectRoutes() {
			return [
				routesNames.HOMEPAGE,
				routesNames.CLIENTS,
				routesNames.CLIENTS_EDIT,
				routesNames.CLIENTS_ADD,
				routesNames.USER_MANAGEMENT,
				routesNames.USER_MANAGEMENT_ADMIN_EDIT,
				routesNames.USER_MANAGEMENT_ADMIN_ADD,
			];
		},
		hasClientNoProjectRoutes() {
			let allowedRoutes = [
				routesNames.PROJECTS,
				routesNames.PROJECTS_EDIT,
				routesNames.PROJECTS_ADD,
				routesNames.USER_MANAGEMENT_CLIENT_ADD,
				routesNames.USER_MANAGEMENT_CLIENT_EDIT,
			];
			return [...this.noClientNoProjectRoutes(), ...allowedRoutes];
		},
	},
};
</script>
<style lang="scss">
.v-main__wrap {
	display: flex;
}
</style>
